export default {

    methods: {
        transferDeptId2Name(deptList, value) {
            let name = '';
            deptList.forEach(e => {
                if (e.id == value) {
                    name = e.name;
                }
            })
            return name;
        },
    },

}